// Debug logger for React app loading issues
export const debugLogger = {
  logComponentRender: (componentName: string, props?: any) => {
    console.log(`🔍 [DEBUG] Rendering component: ${componentName}`, {
      timestamp: new Date().toISOString(),
      props: props ? Object.keys(props) : 'no props',
      stackTrace: new Error().stack?.split('\n').slice(0, 5)
    })
  },

  logComponentError: (componentName: string, error: any) => {
    console.error(`❌ [DEBUG] Component error in ${componentName}:`, {
      timestamp: new Date().toISOString(),
      error: error.message || error,
      stack: error.stack,
      componentName
    })
  },

  logCSSState: () => {
    console.log(`🎨 [DEBUG] CSS State Check:`, {
      timestamp: new Date().toISOString(),
      stylesheets: document.styleSheets.length,
      stylesheetsInfo: Array.from(document.styleSheets).map((sheet, index) => {
        try {
          return {
            index,
            href: sheet.href,
            rulesCount: sheet.cssRules?.length || 'inaccessible',
            disabled: sheet.disabled,
            media: sheet.media.mediaText
          }
        } catch (e) {
          return {
            index,
            href: sheet.href,
            error: e instanceof Error ? e.message : String(e),
            disabled: sheet.disabled
          }
        }
      })
    })
  },

  logAppInitialization: () => {
    console.log(`🚀 [DEBUG] App Initialization:`, {
      timestamp: new Date().toISOString(),
      location: window.location.href,
      userAgent: navigator.userAgent,
      serviceWorker: 'serviceWorker' in navigator,
      localStorage: Object.keys(localStorage),
      documentReadyState: document.readyState
    })
  },

  logStoreState: (storeName: string, state: any) => {
    console.log(`🏪 [DEBUG] Store State - ${storeName}:`, {
      timestamp: new Date().toISOString(),
      state: JSON.stringify(state, null, 2)
    })
  }
}

// Global error boundary for React errors
window.addEventListener('error', (event) => {
  console.error(`🚨 [DEBUG] Global Error:`, {
    timestamp: new Date().toISOString(),
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error?.stack
  })
})

// Catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  console.error(`🚨 [DEBUG] Unhandled Promise Rejection:`, {
    timestamp: new Date().toISOString(),
    reason: event.reason,
    promise: event.promise
  })
})